import { getGFT } from '@/common/utils/ajax'

export const get = (params) => getGFT('v1/credit_agencies', params)

export const SUB_KEY = 'OYOBZ-IFFWP-RUDDH-LM5JW-XYFA7-R5FI4'
